import React, { useState } from 'react'
import CardInfo from './CardInfo'
import { ListDeudaEnvaseHistorialTable } from './ListDeudaEnvaseHistorialTable';
import { BackButton } from '../../../../../components/buttons/ButtonDefault';

export const HistorialGarantia = ({ globalParams }) => {
    const [reload, setReload] = useState(false);
    const [data, setData] = useState(null);
    return (
        <div className='relative'>
            <BackButton />
            <CardInfo
                reload={reload}
                data={data}
                setData={setData}
                globalParams={globalParams}
            />
            <ListDeudaEnvaseHistorialTable
                reload={reload}
                setReload={setReload}
                dataCard={data}
                globalParams={globalParams}
            />
        </div>
    )
}
